import { useMemo } from 'react';
import { CORE_PROJECT, ProjectStyle, SOFTWARE_PROJECT } from '@atlassian/jira-common-constants';
import type { Project } from '@atlassian/jira-common-constants/src/project-types';
import { ff } from '@atlassian/jira-feature-flagging';
import type { SelectedProject } from '@atlassian/jira-issue-create-common-types/src';
import { useTenantContext } from '@atlassian/jira-tenant-context-controller';
import { useX2CModalContext } from './use-x2c-modal-context';

export const transformSelectedProject = (selectedProject: SelectedProject): Project | null => {
	if (selectedProject == null) {
		return null;
	}
	return {
		key: selectedProject.projectKey,
		name: selectedProject.label,
		type: selectedProject.projectType,
		isSimplified: selectedProject.isSimplified,
		style: selectedProject.isSimplified ? ProjectStyle.NEXT_GEN : ProjectStyle.CLASSIC,
		id: Number(selectedProject.value),
		avatarUrl: selectedProject.iconUrl,
	};
};

export const useX2CModal = () => {
	const [{ isModalOpen, project }, { closeModal, openModal, setProject }] = useX2CModalContext();
	const { isSiteAdmin } = useTenantContext();

	const shouldShowX2CModal = useMemo(
		() =>
			ff('enable-x2c-modal-on-gic-import-issues-button_h8c6z') &&
			isSiteAdmin &&
			project &&
			(project.type === SOFTWARE_PROJECT || project.type === CORE_PROJECT),
		[isSiteAdmin, project],
	);

	return {
		isModalOpen,
		shouldShowX2CModal,
		project,
		closeModal,
		openModal,
		setProject,
	};
};
